import React from "react";
import { AHText, AHTextFonts, Box, useScaleFactor, useTheme } from "arkh";
import { DateTime } from "luxon";
import { WidgetTeamScheduleTimeLabelLayout } from "./WidgetTeamScheduleTimeLabelLayout";
import { FormattedMessage } from "react-intl";
export const WidgetTeamScheduleTimeLabel = React.memo(
  WidgetTeamScheduleTimeLabelC
);
function WidgetTeamScheduleTimeLabelC(props: {
  time: string;
  endTime?: string;
  status: "active" | "soon" | "none";
  tint: string;
  isDarkTint: boolean;
}) {
  const theme = useTheme();
  const sf = useScaleFactor();
  const color =
    props.status === "active" && props.isDarkTint ? "lightText" : "darkerText";
  return (
    <Box
      style={{
        alignItems: "center",
        width: WidgetTeamScheduleTimeLabelLayout.width * sf,
      }}
    >
      <Box
        cornerRadius="medium"
        style={{
          alignItems: "center",
          backgroundColor: props.status === "active" ? props.tint : undefined,
        }}
        spaceVertical="xsmall"
        spaceHorizontal="xsmall"
      >
        {props.status === "active" ? (
          <AHText type="subtitle" font={AHTextFonts.BOLDER} color={color}>
            <FormattedMessage
              description="WidgetTeamSchedule Now Label"
              defaultMessage="Now"
            />
          </AHText>
        ) : props.status === "soon" ? (
          <AHText
            type="subtitle"
            style={{ color: props.isDarkTint ? props.tint : theme.darkerText }}
            font={AHTextFonts.BOLDER}
          >
            <FormattedMessage
              description="WidgetTeamSchedule Upcoming Label"
              defaultMessage="Upcoming"
            />
          </AHText>
        ) : null}
        <AHText type="subtitle" font={AHTextFonts.BOLDER} color={color}>
          {DateTime.fromISO(props.time).toLocaleString(DateTime.TIME_24_SIMPLE)}
        </AHText>
        {props.endTime ? (
          <AHText type="detail" color={color}>
            {DateTime.fromISO(props.endTime).toLocaleString(
              DateTime.TIME_24_SIMPLE
            )}
          </AHText>
        ) : null}
      </Box>
    </Box>
  );
}
